<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Specific Body Part :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/incidents">
                            <i class="fa fa-stethoscope"></i> Incidents
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/incidents/settings#body_parts">
                            Settings - Specific Body parts
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="specific_body_part_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> New</template>
                    </li>
                </ol>
            </h4>

            <div class="row mb-4">
                <div class="col-lg-8 col-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.MajorBodyPartId}">Major Body Part:</label>
                                <div class="col-md-6 col-sm-8">
                                    <select v-model="specific_body_part.MajorBodyPartId" :class="{'form-control': true, 'is-invalid': errors.MajorBodyPartId}">
                                        <option :value="null">-- Select a Parent Major Body Part --</option>
                                        <option v-for="(value, key) in major_body_parts" v-bind:value="key">
                                            {{ value }}
                                        </option>
                                    </select>
                                    <span v-if="errors.MajorBodyPartId" class="text-danger">
                                        <span v-for="error in errors.MajorBodyPartId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <label :class="{ 'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.BodyPartName }">Specific Body Part Name:</label>
                                <div class="col-md-6 col-sm-8">
                                    <input type="text" name="BodyPartName" v-model="specific_body_part.BodyPartName" :class="{'form-control': true, 'is-invalid': errors.BodyPartName}" placeholder="Enter Specific Body Part Name" />

                                    <span v-if="errors.BodyPartName" class="text-danger">
                                        <span v-for="error in errors.BodyPartName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-md-6 col-sm-8">
                                    <b-form-checkbox v-model="specific_body_part.IsActive" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button type="button" class="btn btn-success" v-on:click="saveSpecificBodyPart(this)" :disabled="saving">
                Save Specific Body Part
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                specific_body_part_id: this.$route.params.id,
                specific_body_part: {},
                major_body_parts: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getSpecificBodyPart: function() {
                //Get the data
                this.$http
                    .get('admin/specific-body-parts-edit' + (this.specific_body_part_id ? '/' + this.specific_body_part_id : ''))
                    .then(response => {
                        //Set all the data
                        this.specific_body_part = response.data.bodyPart;
                        this.major_body_parts = response.data.majorBodyParts;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveSpecificBodyPart: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/specific-body-parts-edit' + (this.specific_body_part_id ? '/' + this.specific_body_part_id : ''), this.specific_body_part)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Specific Body Part Saved');

                    //Return to main list?
                    this.$router.push('/incidents/settings#body_parts');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getSpecificBodyPart();
        }
    }
</script>
